import { createSlice } from '@reduxjs/toolkit';
import { DeviceSalesReportMeta, DeviceSalesReportRow } from '../../types/device-report/device-report.type';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import snackbarUtils from '../../utils/SnackbarUtils';
import { getDeviceSalesReportData } from './deviceSalesReport.action';

export type DeviceSalesReportState = {
  items: DeviceSalesReportRow[] | null;
  meta: DeviceSalesReportMeta | null;
  fetchStatus: FETCH_STATUS;
};

const INITIAL_STATE: DeviceSalesReportState = {
  items: [],
  meta: null,
  fetchStatus: FETCH_STATUS.NULL,
};

export const deviceSalesReportSlice = createSlice({
  name: 'deviceSalesReport',
  initialState: INITIAL_STATE,
  reducers: {
    resetDeviceSalesReport: () => INITIAL_STATE,
  },
  extraReducers: builder => {
    builder
      .addCase(getDeviceSalesReportData.pending, state => {
        state.fetchStatus = FETCH_STATUS.PENDING;
      })
      .addCase(getDeviceSalesReportData.fulfilled, (state, action) => {
        state.fetchStatus = FETCH_STATUS.FULFILLED;

        state.items = action.payload.items ?? [];
        state.meta = action.payload.meta;
      })
      .addCase(getDeviceSalesReportData.rejected, (state, action) => {
        state.fetchStatus = FETCH_STATUS.REJECTED;

        state.items = [];
        state.meta = null;

        setTimeout(() => {
          snackbarUtils.error((action.payload as string) || 'Failed to generate device sales report');
        });
      });
  },
});

export const { resetDeviceSalesReport } = deviceSalesReportSlice.actions;
export default deviceSalesReportSlice.reducer;
